<template>
  <div class="content">
    <detail-item :title="'订单编号'" :value="income.order_no"></detail-item>
    <detail-item :title="'练车城市'" :value="income.address"></detail-item>
    <detail-item :title="'开始时间'" :value="income.created_at"></detail-item>
    <detail-item :title="'结束时间'" :value="income.end_time"></detail-item>
    <detail-item :title="'计费时长'" :value="income.duration + '分钟'"></detail-item>
    <detail-item :title="'计费单价'" :value="income.unit_price + '元/小时'"></detail-item>
    <detail-item :title="'订单金额'" :value="income.amount + '元'"></detail-item>
    <!-- <detail-item :title="'分成比例'" :value="income.agent_rate"></detail-item> -->
    <detail-item :title="'服务费总额'" :value="income.agent_amount + '元'"></detail-item>
  </div>
</template>
<script>
import detailItem from '@/components/detail_item'
export default {
  data () {
    return {
      income: {}
    }
  },
  components: {
    'detail-item': detailItem
  },
  mounted () {
    let income = this.$route.params.income
    console.log(this.$route.params)
    this.income = income
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  background: #fff;
  padding: 0 .3rem;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/incomeorderdetails/Incomeorderdetails.vue